import type { WalletSummary as Wallet } from "../types/api";
export function WalletSummary({ wallet }: { wallet: Wallet }) {
  return <section className="wallet-summary"><div><span>律所余额</span><strong>¥{wallet.firm_balance}</strong></div><div><span>待分配余额</span><strong>¥{wallet.unallocated_balance}</strong></div></section>;
}
